import { Component, OnInit, Inject } from '@angular/core';

import { NgForm } from '@angular/forms';
import { AdminService } from '../services/admin.service';
import { Office } from '../../shared/models/office.interface';
import { finalize } from 'rxjs/operators';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../models/generic.dialog.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-edit',
  templateUrl: './office.dialog.html',
  styleUrls: ['./office.dialog.scss']
})
export class OfficeDialog implements OnInit {

  constructor(private adminService: AdminService, public dialogRef: MatDialogRef<OfficeDialog>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }
  office: Office;
  states: string[];
  errors: string;
  isRequesting: boolean;
  ngOnInit() {
    
      let officeId: number = this.data.id;

      if (officeId == null) {
        this.office = {} as Office;
        this.office.office_IsActive = true;
      }
      else {
        this.adminService.getOffice(officeId)
          .subscribe({
            next: (data) => {
              this.office = data;
            }
          })
      }

    this.adminService.getStates()
      .subscribe({
        next: (data) => {
          this.states = data;
        }
      })
  }

  saveOffice(form: NgForm) {
    console.log('in office onSubmit: ', this.office);
    this.errors = '';
    this.isRequesting = true;
    if (form.valid) {
      this.isRequesting = true;

      let dealerId = this.adminService.getDealerId();
      this.office.dealer_ID = dealerId;

      this.adminService.saveOffice(this.office)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
          if(result) {
            this.dialogRef.close();
            //this.router.navigate(['/admin/list/office']);
          }
        },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
}
